<template>
  <div class="home-view" style="overflow-x: hidden">
    <div
      class="block"
      v-loading="loadingBanner"
      element-loading-background="rgba(0, 0, 0, 0.3)"
    >
      <action-dispatcher action="home/getBanners">
        <carousel-dots
          v-if="banners.length"
          class="home-banner"
          :space-bottom="true"
        >
          <el-carousel-item
            class="home-banner"
            v-for="banner in banners"
            :key="banner.id"
          >
            <banner-home :item="banner" hideInfos />
          </el-carousel-item>
        </carousel-dots>
        <div class="py-5" v-else></div>
        <div class="soft-divider"></div>
        <template #skeleton>
          <div class="px-5 d-flex align-items-center">
            <banner-skeleton />
          </div>
        </template>
      </action-dispatcher>
      <action-dispatcher action="lives/getLivesMF">
        <section class="pt-lg-5 mb-5" v-if="livesMF">
          <div class="mb-4">
            <div class="row">
              <div class="col-lg-8 col-md-8 col-sm-12">
                <img
                  :src="livesMF.url_banner"
                  class="pt-1 px-sm-3 px-lg-0 px-md-0 ps-lg-5 ps-3 ps-md-3 w-100"
                  v-if="livesMF.url_banner"
                />
                <div
                  class="d-flex flex-column pt-1 px-sm-3 px-lg-0 px-md-0 ps-lg-5 ps-3 ps-md-3 mb-0 w-100"
                  v-if="
                    livesMF.url_video && (isLiveOpen || livesMF.video_aberto)
                  "
                >
                  <h2 class="mb-2 video-title" v-if="livesMF.titulo">
                    <span v-html="livesMF.titulo"></span>
                  </h2>
                  <div class="youtube-container">
                    <iframe
                      v-if="livesMF.url_video"
                      width="560"
                      height="315"
                      :src="livesMF.url_video"
                      :title="livesMF.titulo"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowfullscreen
                    ></iframe>
                  </div>
                  <div v-if="livesMF.url_chat" class="mt-4">
                    <iframe
                      width="100%"
                      height="350"
                      :src="livesMF.url_chat"
                      :title="livesMF.titulo"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowfullscreen
                    ></iframe>
                  </div>
                </div>
                <div
                  v-if="
                    livesMF.url_video && !isLiveOpen && !livesMF.video_aberto
                  "
                >
                  <router-link
                    :to="{
                      name: 'plans',
                    }"
                    title="Assista AO VIVO às conferências do Ministério
                  Fiel! Atualize seu plano para o plano OURO."
                    ><img
                      src="https://ministeriofiel.com.br/wp-content/uploads/2024/06/banner_ao_vivo_atualizar_plano_FD.png"
                      class="pt-1 px-sm-3 px-lg-0 px-md-0 ps-lg-5 ps-3 ps-md-3 w-100"
                      alt="Assista AO VIVO às conferências do Ministério
                  Fiel! Atualize seu plano para o plano OURO."
                      title="Assista AO VIVO às conferências do Ministério
                  Fiel! Atualize seu plano para o plano OURO."
                  /></router-link>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-12">
                <h2
                  class="pt-1 mb-0 pt-sm-3 pt-3 pt-md-0 pt-lg-0 px-sm-3 px-3 live-title"
                  v-if="livesMF.titulo_evento"
                >
                  AO VIVO: <span v-html="livesMF.titulo_evento"></span>
                </h2>
                <p
                  class="pt-2 mb-0 px-sm-3 px-3 live-description"
                  v-if="livesMF.descricao_evento"
                  v-html="livesMF.descricao_evento"
                ></p>
                <a
                  :href="livesMF.url_programacao"
                  target="_blank"
                  v-if="livesMF.url_programacao"
                  title="Ver programação"
                >
                  <img
                    :src="livesMF.url_programacao"
                    class="pt-2 mb-0 px-sm-3 px-3 w-100"
                    v-if="livesMF.url_programacao"
                  />
                </a>
              </div>
            </div>
          </div>
        </section>
      </action-dispatcher>
      <section class="pt-5">
        <h2 class="ps-lg-5 ps-3 mb-2">Devocional do dia</h2>
        <div class="px-lg-5 px-3 pt-2 pb-0">
          <iframe
            src="https://widget.spreaker.com/player?show_id=6040493&theme=dark&playlist=show&playlist-continuous=false&chapters-image=true&episode_image_position=right&hide-logo=true&hide-likes=true&hide-comments=true&hide-sharing=false&hide-download=true"
            width="100%"
            height="350px"
            frameborder="0"
          ></iframe>
        </div>
      </section>
      <action-dispatcher action="courses/getLastLessons">
        <section
          class="pt-lg-5 mb-5"
          v-if="last_lessons && last_lessons.length"
        >
          <h2 class="ps-lg-5 ps-3 mb-0">Continuar assistindo</h2>
          <carousel-playlist
            class="pt-4 pb-lg-5 pb-4"
            :items="last_lessons"
            isKeepWatching
            :show-authors="false"
          />
        </section>
        <template #skeleton>
          <div class="px-5 d-flex align-items-center">
            <lesson-skeleton />
            <lesson-skeleton />
            <lesson-skeleton />
            <lesson-skeleton />
          </div>
        </template>
      </action-dispatcher>
      <action-dispatcher action="home/getCollections">
        <section
          v-for="collection in collections.slice(0, 1)"
          :key="collection.id"
          class="pt-lg-5 mb-5"
        >
          <h2
            v-if="contentCollections.length"
            class="ps-lg-5 ps-3 no-right mb-0"
          >
            {{ collection.name }}
          </h2>

          <carousel-playlist
            v-if="
              contentCollections.length &&
              contentCollections.filter(
                (item) => item.colletion.id == collection.id
              )
            "
            class="pt-4 pb-lg-5 pb-4"
            :items="
              contentCollections.filter(
                (item) => item.colletion.id == collection.id
              )
            "
            :show-progress="false"
            :elementsDesktop="5"
            :elementsMobile="2"
            :show-authors="false"
            :isVertical="true"
            :isHome="true"
          />
        </section>

        <action-dispatcher action="courses/getRecentlyLaunched">
          <section
            class="pt-lg-2"
            v-if="recently_launched && recently_launched.length"
          >
            <h2 class="ps-lg-5 ps-3 mb-0">Lançados nos últimos 12 meses</h2>
            <carousel-playlist
              class="pt-4 pb-lg-5 pb-4"
              :items="recently_launched"
              :show-progress="false"
            />
          </section>
          <template #skeleton>
            <div class="px-5 d-flex align-items-center">
              <lesson-skeleton />
              <lesson-skeleton />
              <lesson-skeleton />
            </div>
          </template>
        </action-dispatcher>

        <action-dispatcher action="courses/getRankedCourses">
          <section
            class="pt-lg-5"
            v-if="ranked_courses && ranked_courses.length"
          >
            <h2 class="px-lg-5 px-3">Top 10 cursos</h2>
            <carousel-playlist
              is-ranked-course
              :slides-offset-after-desktop="150"
              class="pt-4 pb-lg-5 pb-4"
              :items="ranked_courses"
              :show-progress="false"
              :show-infos="false"
              :show-authors="false"
              :elements-desktop="isBigScreen ? 4 : 3"
              :elements-mobile="1.7"
            />
          </section>
          <template #skeleton>
            <div class="px-5 d-flex align-items-center">
              <lesson-skeleton />
              <lesson-skeleton />
              <lesson-skeleton />
            </div>
          </template>
        </action-dispatcher>

        <section
          v-for="collection in collections.slice(1, 3)"
          :key="collection.id"
          class="pt-lg-5 pt-2"
        >
          <h2
            v-if="contentCollections.length"
            class="ps-lg-5 ps-3 no-right mb-0"
          >
            {{ collection.name }}
          </h2>

          <carousel-playlist
            v-if="
              contentCollections.length &&
              contentCollections.filter(
                (item) => item.colletion.id == collection.id
              )
            "
            class="pt-4 pb-lg-5 pb-4"
            :items="
              contentCollections.filter(
                (item) => item.colletion.id == collection.id
              )
            "
            :show-progress="false"
            :isHome="true"
          />
        </section>

        <action-dispatcher action="conferences/getHomeConferences">
          <section class="pt-lg-5" v-if="homeConferences.length">
            <h2 class="px-lg-5 px-3 mb-0">Conferências</h2>
            <div class="pt-4 mx-lg-5 pb-4">
              <conference-preview :items="homeConferences" />
            </div>
          </section>
          <template #skeleton>
            <div class="px-5 d-flex align-items-center justify-content-center">
              <conference-skeleton />
              <conference-skeleton />
            </div>
          </template>
        </action-dispatcher>

        <div class="py-3"></div>

        <section
          v-for="collection in collections.slice(3)"
          :key="collection.id"
          class="pt-lg-5 pt-2"
        >
          <h2
            v-if="contentCollections.length"
            class="ps-lg-5 ps-3 no-right mb-0"
          >
            {{ collection.name }}
          </h2>

          <carousel-playlist
            v-if="
              contentCollections.length &&
              contentCollections.filter(
                (item) => item.colletion.id == collection.id
              )
            "
            class="pt-4 pb-lg-5 pb-4"
            :items="
              contentCollections.filter(
                (item) => item.colletion.id == collection.id
              )
            "
            :show-progress="false"
            :isHome="true"
          />
        </section>
        <template #skeleton>
          <div class="px-5 d-flex align-items-center">
            <lesson-skeleton />
            <lesson-skeleton />
            <lesson-skeleton />
          </div>
        </template>
      </action-dispatcher>

      <action-dispatcher action="courses/getTeachers">
        <section
          v-if="masters_with_content?.length"
          class="pt-lg-5 pb-3 mt-lg-3"
        >
          <h2 class="ps-lg-5 ps-3 no-right mb-0">Nossos mestres</h2>
          <carousel-playlist
            class="pt-4 pb-5"
            masters-avatars
            :items="masters_with_content"
            :elements-mobile="2.5"
            :show-progress="false"
            :show-infos="false"
            :show-authors="false"
            :elements-desktop="9"
          />
        </section>
        <template #skeleton>
          <div class="px-5 d-flex align-items-center">
            <master-skeleton />
            <master-skeleton />
            <master-skeleton />
            <master-skeleton />
            <master-skeleton />
            <master-skeleton />
          </div>
        </template>
      </action-dispatcher>

      <action-dispatcher action="library/getLibrary">
        <section
          v-if="library?.length"
          id="section-library"
          class="pt-5 pb-3 d-flex flex-column flex-lg-row align-items-lg-center"
        >
          <div
            class="ps-lg-5 pe-lg-5 pb-4 pb-lg-0 d-flex flex-column align-items-center align-items-lg-start text-center text-lg-start"
          >
            <h2 class="mb-4 text-nowrap">BIBLIOTECA DIGITAL</h2>
            <p>
              Revistas, livros, audio livros, todo o material que você precisa
              para aprofundar o seu estudo.
            </p>

            <router-link
              :to="{
                name: 'library',
              }"
              class="btn btn-primary library-checkout text-white mt-5"
            >
              Explore a Biblioteca
            </router-link>
          </div>
          <carousel-playlist
            is-basic-book
            class="pt-4 pb-5 w-100"
            :items="library"
            :show-progress="false"
            :show-infos="false"
            :show-authors="false"
            :elements-desktop="5"
            :elements-mobile="2.5"
          />
        </section>
        <template #skeleton>
          <div class="px-5 d-flex align-items-center">
            <library-skeleton />
            <library-skeleton />
            <library-skeleton />
            <library-skeleton />
          </div>
        </template>
      </action-dispatcher>
    </div>
  </div>
</template>

<script>
  import ConferencePreview from "@/components/thumbnails/ConferencePreview";
  import ConferenceSkeleton from "@/components/skeleton/ConferenceSkeleton";
  import LibrarySkeleton from "@/components/skeleton/LibrarySkeleton";
  import BannerSkeleton from "@/components/skeleton/BannerSkeleton";
  import LessonSkeleton from "@/components/skeleton/LessonSkeleton";
  import MasterSkeleton from "@/components/skeleton/MasterSkeleton";
  import CarouselDots from "@/components/thumbnails/CarouselDots";
  import BannerHome from "@/components/course/BannerHome";
  import CarouselPlaylist from "@/components/CarouselPlaylist";
  import ProgressMixin from "@/functions/mixins/progress.js";
  import { mapState } from "vuex";

  export default {
    mixins: [ProgressMixin],
    name: "HomeView",
    components: {
      CarouselDots,
      BannerHome,
      MasterSkeleton,
      LessonSkeleton,
      BannerSkeleton,
      LibrarySkeleton,
      CarouselPlaylist,
      ConferencePreview,
      ConferenceSkeleton,
    },
    data() {
      return {
        loadingBanner: false,
      };
    },
    computed: {
      ...mapState("courses", [
        "banner_courses",
        "recently_launched",
        "highlighted_categories",
        "teachers",
        "ranked_courses",
        "categories",
        "coursesCollection",
        "last_lessons",
      ]),
      ...mapState("home", ["collections", "contentCollections", "banners"]),
      ...mapState("conferences", ["allConferences", "homeConferences"]),
      ...mapState("library", ["library"]),
      ...mapState("lives", ["livesMF"]),
      isBigScreen() {
        return window.innerWidth >= 1500;
      },
      masters_with_content() {
        return this.teachers.filter(
          (m) =>
            m.total_books ||
            m.total_conferences ||
            m.total_courses ||
            m.total_lessons
        );
      },
      isLiveOpen() {
        const allowSignatures = [3, 4, 34, 68, 69, 70];
        const currentSignatureUser =
          this.$store.state.user &&
          this.$store.state.user.user.current_signature
            ? this.$store.state.user.user.current_signature.id
            : 1;
        return allowSignatures.includes(currentSignatureUser);
      },
    },
    mounted() {
      this.$store.dispatch("home/getContentCollections");
      this.$store.dispatch("conferences/getMyList");
      this.$store.dispatch("library/getMyList");
      this.$store.dispatch("courses/getMyList");
      this.dispatchStartedCourses();
      this.dispatchCompletedCourses();
    },
  };
</script>

<style lang="scss" scoped>
  .home-view {
    overflow: hidden;
    margin-top: 76px;
  }

  .home-banner {
    height: 654px;
    @media (max-width: 1520px) {
      height: 615px;
    }
    @media (max-width: 1320px) {
      height: 537px;
    }
    @media (max-width: 1120px) {
      height: 456px;
    }
    @media (max-width: 920px) {
      height: 370px;
    }
    @media (max-width: 720px) {
      height: 300px;
    }
  }

  #section-library {
    background: linear-gradient(
      270.15deg,
      #407f59 0.14%,
      rgba(41, 15, 0, 0) 99.88%
    );

    .library-checkout {
      border-radius: 38px;
      width: 202px;
      height: 38px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    p {
      max-width: 301px;
    }
  }
  .video-container {
    position: relative;
    padding-bottom: 56.25%; /* 16:9 */
    height: 0;
  }
  .video-container iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .live-title,
  .live-description {
    font-size: 19px;
  }
  .video-title {
    font-size: 17px;
  }
  .youtube-container {
    overflow: hidden;
    width: 100%;
    /* Keep it the right aspect-ratio */
    aspect-ratio: 16/9;

    iframe {
      /* Extend it beyond the viewport... */
      width: 300%;
      height: 100%;
      /* ...and bring it back again */
      margin-left: -100%;
    }
  }
</style>
